import axios from "axios";

const BALLPARK_BACKEND_BASE_URL = import.meta.env.VITE_BALLPARK_API_URL;
const BASE_HATTRICK_URL = import.meta.env.VITE_HATTRICK_URL;

export const createTeamProducts = (formObj, filesToUpload, user) => {

    const formData = new FormData();
    formData.append("data", JSON.stringify(formObj));

    filesToUpload.forEach(({ fieldName, file }) => {
        formData.append(fieldName, file)
    });

    let headers = {
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
    };

    console.log("request being send to team product creation: ", formData)
    return axios.post(BASE_HATTRICK_URL + "team/products", formData, {
        headers,
    });
};